import {useIsMediumAndUp} from '~library/hooks/useMatchQuery';

const MOBILE_DEFAULT_WIDTH = '100%';
const MOBILE_DEFAULT_HEIGHT = '242px';
const MOBILE_BLANK_HEIGHT = '420px';

const MEDIUM_DEFAULT_WIDTH = '530.72px';
const MEDIUM_DEFAULT_HEIGHT = '390px';
const MEDIUM_BLANK_HEIGHT = '566.25px';

export interface EnvelopeSizeProps {
  type: string;
}

export interface EnvelopeSizeResult {
  width: number | string;
  height: number | string;
}

export const ENVELOPE_SIZES = {
  default: {
    mobile: {width: MOBILE_DEFAULT_WIDTH, height: MOBILE_DEFAULT_HEIGHT},
    default: {width: MEDIUM_DEFAULT_WIDTH, height: MEDIUM_DEFAULT_HEIGHT},
  },
  blank: {
    mobile: {width: MOBILE_DEFAULT_WIDTH, height: MOBILE_BLANK_HEIGHT},
    default: {width: MEDIUM_DEFAULT_WIDTH, height: MEDIUM_BLANK_HEIGHT},
  },
};

export const useEnvelopeSize = ({type}: EnvelopeSizeProps): EnvelopeSizeResult => {
  const isMediumScreen = useIsMediumAndUp();

  const screenSize = isMediumScreen ? 'default' : 'mobile';

  const envelopeType = type === 'blank' || type === 'flap_down_image' ? 'blank' : 'default';

  const defaultDimensions = ENVELOPE_SIZES[envelopeType][screenSize];

  return {
    width: defaultDimensions.width,
    height: defaultDimensions.height,
  };
};
